import "./style.scss";

const Loader = () => <div className="loader light-loader" />;

export default Loader;
